/* Millo Coins junto a los precios (13-oct-2026). Sacado de la maqueta (web-trabajo/.../assets/mg-demo.js, v=1793200009):
   solo dos piezas, (1) cada «N €» lleva al lado la moneda mg con N y (2) la franja «1 € = 1 Millo Coin» (.mcx).
   mg-demo.js entero no va en el tema: es la demo de la maqueta.
   - 1 € = 1 coin, redondeando hacia abajo: «30,00 €» -> 30 · «286,26 €» -> 286 · «3.900,00 €» -> 3.900. El pago sigue en euros.
     También «€30.00»: en inglés la bolsa (mg-theme.js, Intl) pone el € delante.
   - Solo con la tienda en euros (MG.currency === 'EUR'); en otra moneda no hace nada.
   - Modo: window.MG_PRECIO_COINS, que pone layout/theme.liquid (una sola línea):
       'mixto' (por defecto, Edgar 13-oct) = solo la moneda + cifra en tienda, tarjetas, club y cabeceras; en la ficha y en la bolsa
         (.pr-w, .card2 .pr, .mbz-cmp, .bag, .cartp, .cart) además el € en pequeño al lado (<small class="mcp-eur">), porque es el precio final
       'ambos' = «30,00 €» y la moneda con 30 al lado en todas partes · 'solo' = solo la moneda · 'no' = apagado.
   - Lo que lleve [data-nocoin] no se toca. La bolsa se repinta sola (MutationObserver).
   - La franja va debajo de .coll .subbar (colecciones) o encima de la caja del club (.pdp2 .membox / .mbz, fichas) y lleva a #niveles
     de la ficha del club.
   - Datos del tema en el <script> que carga este archivo: data-coin (imagen de la moneda) y data-niveles (url de la ficha del club#niveles).
   Estilos: .mcp, .mcp-eu, .mcp-eur, .mcx y .mcx-pdp en mg.css (copia de la maqueta).
   El <small> lleva un espacio delante (no se ve): así mg-coins.js, que lee el texto de .pr, sigue leyendo «30 30,00 €» como 30 y no como 3030. */
(function () {
  'use strict';
  var MG = window.MG || {};
  if (MG.currency && MG.currency !== 'EUR') return;
  var MODO = (typeof window.MG_PRECIO_COINS === 'string') ? window.MG_PRECIO_COINS : 'mixto';
  if (MODO === 'no') return;
  var me = document.currentScript || document.querySelector('script[src*="mg-coins-precio"]') || { getAttribute: function () { return ''; } };
  var SRC = me.getAttribute('data-coin') || '';
  var NIV = me.getAttribute('data-niveles') || '/products/millo-gang-membership#niveles';
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

  /* «30,00 €», «3.900,00 €», «286,26 €» (y «30 €» o «1.000 €» como en la maqueta) -> euros enteros, hacia abajo */
  function euros(s) {
    if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else if (/\.\d{1,2}$/.test(s) && !/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/,/g, '');
    else s = s.replace(/[.,]/g, '');
    var n = Math.floor(parseFloat(s));
    return isNaN(n) ? null : n;
  }
  function miles(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, EN ? ',' : '.'); }

  /* (1) precios */
  var CTX = '.pr-w, .card2 .pr, .mbz-cmp, .bag, .cartp, .cart';
  var RX = /(\d[\d.,]*)\s?€|€\s?(\d[\d.,]*)/g, SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, OPTION: 1, TITLE: 1, NOSCRIPT: 1 };
  function ignored(n) {
    var p = n.nodeType === 3 ? n.parentNode : n;
    return !p || SKIP[p.nodeName] || (p.closest && (p.closest('[data-nocoin]') || p.closest('.mcp') || p.closest('.mcp-eu') || p.closest('.mcp-eur')));
  }
  function coinify(root) {
    if (!document.body || !root || !document.body.contains(root) || ignored(root)) return;
    var n, list = [];
    function collect(t) {
      if (t.nodeValue.indexOf('€') >= 0 && !ignored(t)) list.push(t);
    }
    if (root.nodeType === 3) collect(root);
    else {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      while ((n = w.nextNode())) collect(n);
    }
    list.forEach(function (t) {
      var txt = t.nodeValue, frag = document.createDocumentFragment(), last = 0, m, hit = false;
      var eur = MODO === 'mixto' && t.parentNode.closest && t.parentNode.closest(CTX);
      RX.lastIndex = 0;
      while ((m = RX.exec(txt))) {
        var c = euros(m[1] || m[2]); if (c === null) continue;
        hit = true;
        if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
        if (MODO === 'ambos') {
          var eu = document.createElement('span'); eu.className = 'mcp-eu'; eu.textContent = m[0];
          frag.appendChild(eu); frag.appendChild(document.createTextNode(' '));
        }
        var sp = document.createElement('span'); sp.className = 'mcp';
        sp.setAttribute('aria-label', miles(c) + ' Millo Coins');
        var im = document.createElement('img'); im.src = SRC; im.alt = ''; im.width = 64; im.height = 64;
        sp.appendChild(im); sp.appendChild(document.createTextNode(miles(c)));
        frag.appendChild(sp);
        if (eur) { var e2 = document.createElement('small'); e2.className = 'mcp-eur'; e2.textContent = ' ' + m[0]; frag.appendChild(e2); }
        last = RX.lastIndex;
      }
      if (!hit) return;
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last).replace(/^\s*€/, '')));
      t.parentNode.replaceChild(frag, t);
    });
  }

  /* (2) franja «1 € = 1 Millo Coin» */
  function franja() {
    if (document.querySelector('.mcx') || !document.querySelector('.coll, .pdp2')) return;
    var sb = document.querySelector('.coll .subbar'), mb = document.querySelector('.pdp2 .membox, .pdp2 .mbz');
    if (!sb && !mb) return;
    var a = document.createElement('a'); a.className = 'mcx'; a.href = NIV; a.setAttribute('data-nocoin', '');
    /* copy 13-oct, en la voz de Bryant y la gang (Edgar: «son de Puerto Rico, llévalo a su terreno, a su familia»): cada euro cuenta, 1 € = 1 coin,
       y lo de Bryant no se vende, se gana en la familia */
    /* 14-oct: el miembro al día gana 1,5 por euro (panel) */
    var SOCIO = !!(window.MG_COINS && window.MG_COINS.socio === true);
    a.innerHTML = '<span class="mcx-eq"><small class="mcx-k">' + (EN ? 'Members only' : 'Solo miembros') + '</small><b>' + (EN ? '€1' : '1 €') + '</b><i>=</i><img src="' + SRC + '" alt=""><b>' + (EN ? '1.5 Millo Coins' : '1,5 Millo Coins') + '</b></span>'
      /* 14-oct: fuera la frase «Lo de Bryant no se vende: se gana en la familia» (Edgar: «quita este copy») */
      + '<span class="mcx-go">' + (EN ? 'See levels' : 'Ver niveles') + ' &rarr;</span>';
    if (sb) sb.parentNode.insertBefore(a, sb.nextSibling);
    else { a.classList.add('mcx-pdp'); mb.parentNode.insertBefore(a, mb); }
  }

  var busy = 0, all = false, pending = [];
  function run(root) {
    if (!root) { all = true; pending = []; }
    else if (!all) {
      /* Una actualización de bolsa puede añadir el padre y cambiar varios hijos:
         se recorre solo la raíz mínima, una vez por fotograma. */
      for (var i = pending.length - 1; i >= 0; i--) {
        if (pending[i] === root || (pending[i].contains && pending[i].contains(root))) return;
        if (root.contains && root.contains(pending[i])) pending.splice(i, 1);
      }
      pending.push(root);
    }
    if (busy) return; busy = 1;
    requestAnimationFrame(function () {
      var roots = all ? [document.body] : pending;
      all = false; pending = [];
      try { franja(); roots.forEach(coinify); } finally { busy = 0; }
    });
  }
  /* 60 ms después de DOMContentLoaded, como en la maqueta: mg-club.js lee antes el precio del paso 01 para la cuenta 408,95 -> 286,26 */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 60); });
  else setTimeout(run, 60);
  try {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].type === 'characterData') {
          var t = ms[i].target;
          if (t.nodeValue.indexOf('€') >= 0 && !ignored(t)) run(t);
        } else {
          for (var j = 0; j < ms[i].addedNodes.length; j++) {
            var n = ms[i].addedNodes[j];
            if ((n.nodeType === 1 || (n.nodeType === 3 && n.nodeValue.indexOf('€') >= 0)) && !ignored(n)) run(n);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();
